import { render, staticRenderFns } from "./RadioCurrentCheck.vue?vue&type=template&id=07a1b32b&scoped=true"
import script from "./RadioCurrentCheck.vue?vue&type=script&lang=js"
export * from "./RadioCurrentCheck.vue?vue&type=script&lang=js"
import style0 from "./RadioCurrentCheck.vue?vue&type=style&index=0&id=07a1b32b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a1b32b",
  null
  
)

export default component.exports